<template>
  <div style="display: flex; gap: 1em; flex-direction: column">
    <div style="display: flex; justify-content: space-between">
      <h2 style="color: #32c040; font-weight: bold">Location</h2>
      <div style="display: flex; gap: 0.5em">
        <b-button variant="light">
          <div style="display: flex; align-items: center; gap: 0.5em">
            <span
              class="material-icons"
              style="font-size: 16px; font-weight: 100"
            >
              settings
            </span>
            Parts Logs
          </div>
        </b-button>
        <b-button variant="light">
          <div style="display: flex; align-items: center; gap: 0.5em">
            <span
              class="material-icons"
              style="font-size: 16px; font-weight: 100"
            >
              format_list_bulleted
            </span>
            Bulk Actions
          </div>
        </b-button>
        <b-button variant="outline-light">
          <div style="display: flex; align-items: center; gap: 0.5em">
            <span
              class="material-icons"
              style="font-size: 16px; font-weight: 100; color: #32c040"
            >
              settings
            </span>
          </div>
        </b-button>
      </div>
    </div>
    <div class="m-card">
      <div style="display: flex; justify-content: flex-end">
        <b-button variant="success">SAVE</b-button>
      </div>
      <Tree :value="treeData">
        <span slot-scope="{ node, index, path, tree }">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div style="display: flex; align-items: center">
              <b
                @click="tree.toggleFold(node, path)"
                style="cursor: pointer"
                v-if="node.children.length > 0"
              >
                <span class="material-icons-outlined">
                  {{ node.$folded ? "arrow_right" : "arrow_drop_down" }}
                </span>
              </b>
              <b v-else>
                <span class="material-icons-outlined"> remove </span>
              </b>
              <span v-if="node.children.length > 0">
                {{ node.text }}
              </span>
              <span v-else @click="goto(node, path, index)">
                {{ node.text }}
              </span>
            </div>
            <div>
              <b-button variant="light" @click="addNode(node, path)">
                <span
                  class="material-icons"
                  style="font-size: 16px; font-weight: 100"
                >
                  add
                </span>
              </b-button>
              <b-button variant="light" @click="copyNode(node, path)">
                <span
                  class="material-icons"
                  style="font-size: 16px; font-weight: 100"
                >
                  folder_copy
                </span>
              </b-button>
              <b-button variant="light" @click="editName(node, path)">
                <span
                  class="material-icons"
                  style="font-size: 16px; font-weight: 100"
                >
                  border_color
                </span>
              </b-button>
              <b-button variant="light" @click="removeNode(path)">
                <span
                  class="material-icons"
                  style="font-size: 16px; font-weight: 100"
                >
                  delete
                </span>
              </b-button>
            </div>
          </div>
        </span>
      </Tree>
    </div>
  </div>
</template>

<script>
import {
  Tree, // Base tree
  Fold,
  Check,
  Draggable, // plugins
  foldAll,
  unfoldAll,
  cloneTreeData,
  walkTreeData,
  getPureTreeData, // utils
} from "he-tree-vue";
import "he-tree-vue/dist/he-tree-vue.css"; // base style
export default {
  components: { Tree: Tree.mixPlugins([Draggable, Fold]) },
  data() {
    return {
      treeData: [
        { text: "node 1", $folded: false, children: [] },
        {
          text: "node 2",
          $folded: false,
          children: [
            {
              text: "node 2-1",
              $folded: false,
              children: [
                {
                  text: "node 2-1-1",
                  $folded: false,
                  children: [
                    { text: "node 2-1-1-1", $folded: false, children: [] },
                  ],
                },
              ],
            },
          ],
        },
      ],
    };
  },
  methods: {
    goto(node, path, index) {
      console.log(node, path, index);
      let el = this.treeData;
      let query = "";
      query += query + el[path[0]].text;
      if (path.length > 1) {
        el = el[path[0]];
        console.log(el);
        for (let i = 1; i < path.length - 1; i++) {
          console.log(i);
          el = el.children[path[i]];
          query += query + "," + el.text;
        }
        el = el.children;
          query += query + "," + el[path[path.length - 1]].text;

      }
      console.log(el);
      console.log(query);
      this.$router.push('/inventory/info')
    },
    addNode(node, path) {
      console.log(node, path);
      if (node.children == undefined) {
        node.children = [{ text: "new node", $folded: false, children: [] }];
      } else {
        node.children.push({ text: "new node", $folded: false, children: [] });
      }
    },
    copyNode(node, path) {
      //   console.log(node, path);
      let el = this.treeData;
      if (path.length > 1) {
        el = el[path[0]];
        console.log(el);
        for (let i = 1; i < path.length - 1; i++) {
          console.log(i);
          el = el.children[path[i]];
        }
        el = el.children;
      }

      // clone Object
      let copy_node = JSON.parse(JSON.stringify(node));
      (copy_node.text = copy_node.text + "-copy"),
        el.splice(path[path.length - 1] + 1, 0, copy_node);
    },
    editName(node, path) {
      // input in alert
      let new_name = prompt("Enter new name");
      node.text = new_name;
    },
    removeNode(path) {
      // console.log(this.treeData);
      let el = this.treeData;
      if (path.length > 1) {
        el = el[path[0]];
        console.log(el);
        for (let i = 1; i < path.length - 1; i++) {
          console.log(i);
          el = el.children[path[i]];
        }
        el = el.children;
      }
      el.splice(path[path.length - 1], 1);
    },
  },
};
</script>

<style lang="scss" >
.he-tree {
  .tree-children.tree-root {
    .tree-branch {
      .tree-node-back {
        .tree-node {
          border: none;
        }
      }
      .tree-children {
        .tree-branch {
          .tree-node-back {
            .tree-node {
            }
          }
        }
      }
    }
  }
}
</style>